// src/App.js
import React from 'react';
import './App.css';
import PowerBIReport from '../src/components/PowerBIReport';
import PowerBIReportVF from './components/PowerBIReportVF';
import { useIsAuthenticated } from "@azure/msal-react";
import LoginButton from './components/LoginButton';
import { useMsal } from "@azure/msal-react";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";

import Login from './components/Login';
import MainReport from './components/MainReport';
import MainWorkSpaces from './components/MainWorkSpaces';
import UserRoles from './components/UserRoles';
import LoadExcelProcessEquifax from './components/LoadExcelProcessEquifax'
import ProjectManager from './components/ProjectManager';
import Manager from './components/Manager';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import News from './components/News';
import NewsManager from './components/NewsManager';
import Indicadores from './components/Indicadores';

function App() {

  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();

  const account = instance.getActiveAccount(); // Obtiene la cuenta activa
  //console.log(account);
  //console.log(isAuthenticated);
  //console.log(instance);

  const hasActiveSession = () => {
    const accounts = instance.getAllAccounts();
    return accounts.length > 0;
  };


  return (
  <Router>
    <Routes>
      <Route
        path="/"
        element={
          <Navigate to={isAuthenticated ? "/mainreport" : "/login"} replace />
        }
      />
      <Route path="/login" element={<Login />} />
      <Route path="/mainreport" element={<MainReport />} />
      <Route path="/mainworkspace" element={<MainWorkSpaces />} />
      <Route path="/userroles" element={<UserRoles />} />
      <Route path="/loadexcelprocess" element={<LoadExcelProcessEquifax />} />
      <Route path="/projects" element={<ProjectManager />} />
      <Route path="/manager" element={<Manager />} />
      <Route path="/news" element={<News />} />
      <Route path="/newsmanager" element={<NewsManager />} />
      <Route path="/indicadores" element={<Indicadores />} />
    </Routes>

    <ToastContainer
        position="top-right"
        autoClose={5000}  // ⏱️ se cierra a los 5s
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
  </Router>
  );

}

export default App;